














































































































































































import Vue from "vue";
import Component from "vue-class-component";
import {
  FactFindDependentDto,
  YesNoDefaultDto,
  OwnerDto,
  GenderDto,
  PersonalRelationDto,
  EmploymentStatusDto,
  CreateDependantCommand,
  UpdateDependantCommand,
  ClientSelector
} from "@/api/ClientPortalApiClient";
import CbxOwner from "@/views/lookups/CbxOwner.vue";
import CbxGender from "@/views/lookups/CbxGender.vue";
import CbxYesNoDefault from "@/views/lookups/CbxYesNoDefault.vue";
import CbxPersonalRelation from "@/views/lookups/CbxPersonalRelation.vue";
import CbxEmploymentStatus from "@/views/lookups/CbxEmploymentStatus.vue";
import CbxYesNo from "@/views/lookups/CbxYesNo.vue";
import ApiFactory from "../../api/ApiFactory";
import AlertService from "../../services/alert.service";
import { LoadingSpinnerService } from "@/store";
import { FormatDate } from "@/filters/FormatDate";

@Component({
  components: {
    CbxOwner,
    CbxGender,
    CbxPersonalRelation,
    CbxYesNoDefault,
    CbxEmploymentStatus
  }
})
export default class FactFindDependants extends Vue {
  private alertService = new AlertService();
  private dependants: FactFindDependentDto[] = [];
  private emptyDependant = new FactFindDependentDto();
  private selectDependant = new FactFindDependentDto();
  private displayModel = new FactFindDependentDto();
  private formEnabled: boolean = false;
  private mode: string = "default";
  private modelSig = "";
  private contactId: number = 0;

  // private dateOfBirth = "";

  $refs!: {
    owner: CbxOwner;
    gender: CbxGender;
    relation: CbxPersonalRelation;
    employment: CbxEmploymentStatus;
    financial: CbxYesNoDefault;
    mainForm: HTMLFormElement;
  };

  public created() {
    this.contactId = parseInt(this.$route.params.contactId);
    this.getDependants(true);
  }

  private saveDependant(e: Event) {
    e.preventDefault();
    if (this.mode === "update") {
      this.update();
    } else if (this.mode === "create") {
      this.createNew();
    }
  }

  private async createNew(): Promise<boolean> {
    LoadingSpinnerService.Show("Saving new dependant...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new CreateDependantCommand();

    cmd.contactId = this.contactId;
    cmd.guardian = this.displayModel.guardian;
    cmd.firstName = this.displayModel.firstName;
    cmd.lastName = this.displayModel.lastName;
    cmd.dateOfBirth = this.displayModel.dateOfBirth;
    cmd.age = this.displayModel.age;
    cmd.taxNumber = this.displayModel.taxNumber;
    cmd.sex = this.displayModel.sex;

    if (this.displayModel.relation) {
      cmd.relationId = this.displayModel.relation.id;
    }
    if (this.displayModel.employmentStatus) {
      cmd.employmentStatusID = this.displayModel.employmentStatus.id;
    }
    if (this.displayModel.isFinanciallyDependant) {
      cmd.isFinanciallyDependantId = this.displayModel.isFinanciallyDependant.id;
    }

    try {
      const result = await api.factFindDependent_IndexPOST(cmd);
      this.displayModel.id = result;
      await this.getDependants();
      this.displayModel =
        this.dependants.find(x => x.id === result) || this.displayModel;

      this.mode = "update";
      this.modelSig = this.displayModel.toJSON();
      LoadingSpinnerService.Success("Dependant saved successfully");
      return true;
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Could not save dependant. Please try again."
      );
    }

    return false;
  }

  private async update(): Promise<boolean> {
    LoadingSpinnerService.Show("Updating dependant...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new UpdateDependantCommand();

    cmd.contactId = this.contactId;
    cmd.id = this.displayModel.id;
    cmd.guardian = this.displayModel.guardian;
    cmd.firstName = this.displayModel.firstName;
    cmd.lastName = this.displayModel.lastName;
    cmd.dateOfBirth = FormatDate.forApi(this.displayModel.dateOfBirth);
    cmd.age = this.displayModel.age;
    cmd.taxNumber = this.displayModel.taxNumber;
    cmd.sex = this.displayModel.sex;

    if (this.displayModel.relation) {
      cmd.relationId = this.displayModel.relation.id;
    }
    if (this.displayModel.employmentStatus) {
      cmd.employmentStatusID = this.displayModel.employmentStatus.id;
    }
    if (this.displayModel.isFinanciallyDependant) {
      cmd.isFinanciallyDependantId = this.displayModel.isFinanciallyDependant.id;
    }

    try {
      var result = await api.factFindDependent_IndexPUT(cmd);
      if (result) {
        this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
        LoadingSpinnerService.Success("Dependant updated successfully");
        return true;
      } else {
        LoadingSpinnerService.Failure(
          "Could not save dependant. Please try again."
        );
      }
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Could not save dependant. Please try again."
      );
    }

    return false;
  }

  private async getDependants(showLoader: boolean | undefined = undefined) {
    if (showLoader) LoadingSpinnerService.Show("Loading dependants...");
    const api = ApiFactory.CreateDataClient();

    try {
      const result = await api.factFindDependent_IndexAll(this.contactId);
      this.dependants = result || [];
      if (showLoader) LoadingSpinnerService.Hide();
    } catch (e) {
      this.dependants = [];
      LoadingSpinnerService.Failure(
        "Could not load dependants. Please try again."
      );
    }
  }

  private async rowSelected(item: FactFindDependentDto) {
    if (!(await this.checkForChanges())) {
      return;
    }

    this.clearData();
    this.formEnabled = true;
    this.mode = "update";
    this.displayModel = item;

    this.displayModel.dateOfBirth = FormatDate.forInput(
      this.displayModel.dateOfBirth
    );

    this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();

    //this.dateOfBirth = item.dateOfBirth;
    if (this.displayModel.guardian) {
      this.$refs.owner.setSelected(this.displayModel.guardian);
    } else {
      this.$refs.owner.setSelected(ClientSelector.Main);
    }
    if (this.displayModel.sex) {
      this.$refs.gender.setSelectedName(this.displayModel.sex);
    } else {
      this.$refs.gender.setSelected(new GenderDto());
    }
    this.$refs.relation.setSelected(this.displayModel.relation);
    this.$refs.employment.setSelected(this.displayModel.employmentStatus);
    this.$refs.financial.setSelected(this.displayModel.isFinanciallyDependant);
  }

  private saveClicked() {
    this.formEnabled = false;
    this.clearData();
    this.mode = "default";
  }

  private createClicked() {
    this.clearData();
    this.mode = "create";
    this.formEnabled = true;
  }

  private updateClicked() {
    this.mode = "update";
    this.formEnabled = true;
  }

  private clearData() {
    this.displayModel = this.emptyDependant;
    //this.dateOfBirth = "";
    this.$refs.owner.setSelected(ClientSelector.Main);
    this.$refs.gender.setSelected(new GenderDto());
    this.$refs.relation.setSelected(new PersonalRelationDto());
    this.$refs.employment.setSelected(new EmploymentStatusDto());
    this.$refs.financial.setSelected(new YesNoDefaultDto());
  }

  public async checkForChanges(): Promise<boolean> {
    if (this.isDisplayModelEmpty() === false) {
      if (this.hasChanges() == true) {
        if (confirm("Would you like to save your changes?")) {
          return await this.saveChanges();
        }
      }
    }

    return true;
  }

  public async saveChanges(): Promise<boolean> {
    if (this.$refs.mainForm.checkValidity()) {
      if (this.mode === "update") {
        return await this.update();
      } else if (this.mode === "create") {
        return await this.createNew();
      }

      return true;
    }

    this.alertService.error(
      "Form Validation Failed",
      "Please complete all required fields"
    );
    return false;
  }

  private isDisplayModelEmpty(): boolean {
    return (
      this.mode !== "create" &&
      JSON.stringify(this.displayModel.toJSON()) ===
        JSON.stringify(this.emptyDependant.toJSON())
    );
  }

  private hasChanges(): boolean {
    const s1 = JSON.stringify(this.displayModel.toJSON()).toString();
    if (s1 !== this.modelSig) {
      return true;
    } else {
      return false;
    }
  }

  private ownerSelected(owner: ClientSelector) {
    this.displayModel.guardian = owner;
  }
  private genderSelected(gender: GenderDto) {
    this.displayModel.sex = gender.name;
  }
  private financialSelected(financial: YesNoDefaultDto) {
    this.displayModel.isFinanciallyDependant = financial;
  }
  private relationSelected(relation: PersonalRelationDto) {
    this.displayModel.relation = relation;
  }
  private employementStatus(employment: EmploymentStatusDto) {
    this.displayModel.employmentStatus = employment;
  }
}
